import { Button } from "components/common/button/Button";
import { Input, InputInfoMsg } from "components/common/input/Input";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next"
import { stepAtom } from "store/signUpStore";
import { useAlert } from "contexts/AlertContext";
import './SignUpStep5.css'
import { Device } from "common/device";

export const SignUpStep5 = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const { showAlert } = useAlert();
    const [step, setStep] = useAtom(stepAtom);
    
    //input
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [nickName, setNickName] = useState("");

    //input Info Msg
    const [emailInfoMsg, setEmailInfoMsg] = useState<InputInfoMsg>();
    const [passwordInfoMsg, setPasswordInfoMsg] = useState<InputInfoMsg>();
    const [nickNameInfoMsg, setNickNameInfoMsg] = useState<InputInfoMsg>();

    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isPwdValid, setIsPwdValid] = useState(false);
    const [isNickNameValid, setIsNickNameValid] = useState(false);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const pwdRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/;


    const checkPwdValid = () => {

        const isPwdLengthValid = password.length >= 8;
        const isPwdRegexValid = (/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/).test(password);
        const isPwdConfirmValid = password === confirmPassword;
        const isPwdValid = isPwdLengthValid && isPwdRegexValid && isPwdConfirmValid;

        setPasswordInfoMsg(
            isPwdLengthValid ?
            isPwdRegexValid ?
            isPwdConfirmValid ?
            undefined :
            {
                msg: t("signUp.passwordNotMatch"),
                type: "error"
            } :
            {
                msg: t("signUp.passwordErrorMsg2"),
                type: "error"
            } :
            {
                msg: t("signUp.passwordErrorMsg1"),
                type: "error"
            }
        );
        setIsPwdValid(isPwdValid);

    }

    useEffect(() => {
        if(email.trim().length <= 0) {
            setEmailInfoMsg(undefined);
            setIsEmailValid(false);
        } else {
            const isValid = emailRegex.test(email);
            setEmailInfoMsg(isValid ? undefined : {
                msg: t("signUp.emailErrorMsg"),
                type: "error"
            })
            setIsEmailValid(isValid);
        }
    },[email])

    useEffect(() => {
        if(password.length <= 0) {
            setIsPwdValid(false);
            setPasswordInfoMsg(undefined);
            return;
        }
        checkPwdValid();
    },[password, confirmPassword]);

    useEffect(() => {
        if(nickName.trim().length <= 0) {
            setNickNameInfoMsg(undefined);
            setIsNickNameValid(false);
        } else {
            const isNickNameLengthValid = nickName.length <= 6;
            setNickNameInfoMsg(
                isNickNameLengthValid ?
                undefined :
                {
                    msg: t("signUp.nickNameErrorMsg2"),
                    type: "error"
                }
            );
            setIsNickNameValid(isNickNameLengthValid);
        }
    },[nickName])

    return (
        <div className="sign-up-step-5" style={{display: step === 5 ? "block" : "none"}}>

            {/* 이메일 */}
            <Input
                title={t("signUp.email")}
                inputVal={email}
                setInputVal={setEmail}
                id="email"
                type="email"
                infoMsg={emailInfoMsg}
                placeholder={t("signUp.emailPlaceHolder")}
                isRequired
            />

            {/* 비밀번호 */}
            <Input
                title={t("signUp.password")}
                inputVal={password}
                setInputVal={setPassword}
                id="password"
                type="password"
                notShowInfo
                placeholder={t("signUp.passwordPlaceHolder")}
                containerStyle={{padding: "10px 0 0"}}
                isRequired
            />
            <Input
                inputVal={confirmPassword}
                setInputVal={setConfirmPassword}
                id="passwordConfirm"
                type="password"
                placeholder={t("signUp.passwordConfirmPlaceHolder")}
                infoMsg={passwordInfoMsg}
            />

            {/* 닉네임 */}
            <Input
                title={t("signUp.nickName")}
                inputVal={nickName}
                setInputVal={setNickName}
                id="nickName"
                type="text"
                infoMsg={nickNameInfoMsg}
                placeholder={t("signUp.nickNamePlaceHolder")}
                isRequired
            />

            <div style={{position: 'fixed', bottom: Device.inset.navigationBarHeight, width: '100%', left: 0, padding: "0 20px 20px"}}>
                <Button
                    text={t("signUp.btnSignUpCom")}
                    disabled={!isEmailValid || !isPwdValid || !isNickNameValid}
                    onPress={async () => {
                        // 프로토타입: 회원가입 완료 후 로그인 페이지로 이동
                        await showAlert({ message: '회원가입이 완료되었습니다!' });
                        navigate('/login');
                        // TODO: 실제 회원가입 API 연동
                    }}
                />
            </div>
        </div>
    )
}